// extracted by mini-css-extract-plugin
export default {"title":"Subtitle_title__gwQAV"};